import { Link } from "react-router-dom";

export default function ServiceThree({services=[], showChip=true}) {
  return (
    <section id="services">
      <div className="w-full what-we-do-wrapper mb-16 pt-16  md:pb-[153px] relative overflow-x-hidden">
        <div className="mx-auto theme-container px-4">
          <div className="w-full">
            <div className="flex justify-center w-full title-area">
              <div className="flex flex-col items-center">
                {showChip && (
                  <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5">
                    What We Do
                  </h1>
                )}
        
                <div className="mb-10 sm:mb-[70px]">
                <h2 className="text-34 sm:text-34 text-center md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
                    Solutions That Drive Digital Success
                  </h2>
                </div>
              </div>
            </div>
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-[30px]">
              {services.map((service, idx) => (
                <Link
                  key={idx}
                  to={`/service/${service.slug}`}
                  data-aos="fade-left"
                  data-aos-delay={service.delay}
                  className="service-item p-5 md:p-[50px] relative group cursor-pointer"
                >
                  <div className="service-item-ico w-[80px] h-[80px] rounded-[10px] flex justify-center items-center mb-7 md:mb-[28px]">
                    <img
                      src={service.icon}
                      alt={`icon-${idx + 1}`}
                      className="relative z-10"
                    />
                  </div>
                  <h1 className="mb-5 font-medium text-white">
                    {service.title}
                  </h1>
                  <p className="text-white opacity-55">{service.description}</p>
                  <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full transition duration-300 ease-in-out opacity-0 circle-shape group-hover:opacity-100">
                    <img
                      src="/assets/images/home-four/service-circle-shape.webp"
                      alt="hover-shape"
                    />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
